export function FamilyMilestonesStoryDetails() {
  const STORY_PROMPTS = [
    'What made this family milestone special?',
    'What traditions or customs were observed?',
    'What were the most memorable moments?',
    'How did this milestone bring the family closer?',
    'What emotions were felt during this time?',
    'What legacy or impact did this milestone create?'
  ]

  return (
    <div className="space-y-12">
      {/* Story Section */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Your Story</h2>
        
        <div className="bg-white rounded-lg p-8 border border-gray-200">
          {STORY_PROMPTS.map((prompt) => (
            <div key={prompt} className="mb-8 last:mb-0">
              <label className="block text-lg text-gray-700 font-medium mb-3">
                {prompt}
              </label>
              <textarea
                className="w-full h-32 p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
                placeholder="Share your memories..."
              />
            </div>
          ))}
        </div>
      </div>

      {/* Family Members */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Family Members Present</h2>
        
        <div className="bg-white rounded-lg p-8 border border-gray-200">
          <div className="flex flex-wrap gap-4">
            {['Parents', 'Siblings', 'Children', 'Extended Family', 'In-Laws'].map((person) => (
              <span
                key={person}
                className="px-6 py-3 text-lg rounded-full bg-gray-100 text-gray-700"
              >
                {person}
              </span>
            ))}
            <button className="px-6 py-3 text-lg rounded-full bg-[#556B2F] text-white">
              Add Person
            </button>
          </div>
        </div>
      </div>

      {/* Media Upload */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Photos & Documents</h2>
        
        <div className="bg-white rounded-lg p-8 border border-gray-200">
          <div className="flex flex-col md:flex-row gap-8">
            <div className="border-2 border-dashed border-[#556B2F] rounded-lg p-8 text-center min-w-[250px]">
              <span className="text-lg text-[#556B2F]">Upload Files</span>
            </div>
            <div className="space-y-4">
              <p className="text-lg text-gray-700">Suggested items:</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
                <p className="text-lg text-gray-600">• Family photos</p>
                <p className="text-lg text-gray-600">• Ceremony photos</p>
                <p className="text-lg text-gray-600">• Legal documents</p>
                <p className="text-lg text-gray-600">• Video recordings</p>
                <p className="text-lg text-gray-600">• Family tree</p>
                <p className="text-lg text-gray-600">• Celebration photos</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
} 